<template>
	<div class="block-footer">
		<div class="title">
			<div class="title-container" v-for="(item, index) of details" :key="'detail' + index">
				<span class="label">{{ item.name }}</span>
				<span class="detail">{{ item.value }}</span>
			</div>
		</div>
		<div class="list">
			<component
				:is="getItemTag(item)"
				v-for="(item, index) of lists"
				:key="'list' + index"
				class="flex qualification-item"
				:href="getItemHref(item)"
				:rel="item.rel"
				@click="handleItemClick(item, $event)"
			>
				<div class="flex start">
					<div>
						<span class="main">{{ item.title }}</span>
						<span class="sub">{{ item.sub }}</span>
					</div>
				</div>
				<van-icon name="arrow" color="#595959" size="14" />
			</component>
		</div>
		<!-- 版权信息 -->
		<div class="copyright">
			<span>© 中国医疗器械有限公司 版权所有</span>
		</div>
	</div>
</template>
<script setup>
import { showImagePreview } from 'vant';

const details = [
	{
		name: '监管机构：',
		value: '国家药品监督管理局 湖北省药品监督管理局',
	},
	{
		name: '联系地址：',
		value: '武汉市东湖新技术开发区高新大道666号CRO办公区B栋',
	},
	{
		name: '联系电话：',
		value: '027-59356195',
	},
];

const lists = [
	{
		title: '互联网药品信息服务备案凭证',
		sub: '鄂网药信备字（2025）00078号',
		url: [
			'https://pro-cmdc.oss-cn-beijing.aliyuncs.com/staticFile/www/websiteLicensefile/main/%E8%B5%84%E8%B4%A8%E6%B0%B4%E5%8D%B0%E6%9B%B4%E6%96%B0-%E4%B8%BB%E7%AB%99%E7%82%B9/2025/%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81.jpg',
		],
	},
	{
		title: 'ICP备案证书号',
		sub: '鄂ICP备19010827号-4',
		url: 'https://beian.miit.gov.cn/',
		rel: 'nofollow',
	},
	{
		title: '增值电信业务经营许可证',
		sub: '鄂B2-20210044',
		url: [
			'https://pro-cmdc.oss-cn-beijing.aliyuncs.com/staticFile/www/websiteLicensefile/main/%E8%B5%84%E8%B4%A8%E6%B0%B4%E5%8D%B0%E6%9B%B4%E6%96%B0-%E4%B8%BB%E7%AB%99%E7%82%B9/2025/%E5%A2%9E%E5%80%BC%E7%94%B5%E4%BF%A1%E4%B8%9A%E5%8A%A1%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg',
		],
	},
	{
		title: '医疗器械网络交易服务第三方平台备案凭证',
		sub: '(鄂)网械平台备字[2021]第00002号',
		url: [
			'https://pro-cmdc.oss-cn-beijing.aliyuncs.com/staticFile/www/websiteLicensefile/main/%E8%B5%84%E8%B4%A8%E6%B0%B4%E5%8D%B0%E6%9B%B4%E6%96%B0-%E4%B8%BB%E7%AB%99%E7%82%B9/2025/%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BD%91%E7%BB%9C%E4%BA%A4%E6%98%93%E6%9C%8D%E5%8A%A1%E7%AC%AC%E4%B8%89%E6%96%B9%E5%B9%B3%E5%8F%B0%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81%EF%BC%88%E9%84%82%EF%BC%89%E7%BD%91%E6%A2%B0%E5%B9%B3%E5%8F%B0%E5%A4%87%E5%AD%97%5B2021%5D%E7%AC%AC00002%E5%8F%B7.jpg',
		],
	},
	{
		title: '营业执照',
		sub: '统一社会信用代码91110000100006047Y',
		url: [
			'https://pro-cmdc.oss-cn-beijing.aliyuncs.com/staticFile/www/websiteLicensefile/main/%E8%B5%84%E8%B4%A8%E6%B0%B4%E5%8D%B0%E6%9B%B4%E6%96%B0-%E4%B8%BB%E7%AB%99%E7%82%B9/2025/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
		],
	},
];

const getItemHref = item => (item.rel && typeof item.url === 'string' ? item.url : undefined);

const getItemTag = item => (getItemHref(item) ? 'a' : 'div');

const handleItemClick = (item, event) => {
	if (Array.isArray(item.url)) {
		event?.preventDefault?.();
		showImagePreview({
			images: item.url,
			startPosition: 0,
			closeable: true,
		});
		return;
	}

	if (typeof item.url === 'string' && !item.rel) {
		window.location.href = item.url;
	}
};
</script>
<style lang="scss" scoped>
.block-footer {
	padding-top: 8px;
	background: transparent;

	.title {
		padding: 0 12px 0.75rem;
		line-height: 1.7rem;
		display: flex;
		flex-direction: column;

		.title-container {
			display: flex;
		}

		.label {
			color: #1f2937;
			display: inline-block;
			width: 70px;
			text-align: right;
			vertical-align: top;
			white-space: nowrap;
		}

		.detail {
			display: inline-block;
			flex: 1;
			color: #1f2937;
			vertical-align: top;
		}
	}
}

.list {
	> .qualification-item {
		padding: 8px 20px;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:not(:last-child) {}

		border-bottom: 0.1rem solid #ced3d9;

		&:first-child {
			border-top: 0.1rem solid #ced3d9;
		}
	}

	.qualification-item {
		text-decoration: none;
		color: inherit;
	}

	.flex {
		flex: 1;
		min-width: 0;

		span {
			line-height: 1.6rem;
		}

		.main {
			display: block;
			color: #6b7280;
		}

		.sub {
			display: block;
			color: #1f2937;
		}
	}
}

.icon-maijia_zhengzhao {
	font-size: 3rem;
	margin-right: 0.5rem;
	color: rgba(255, 255, 255, 0.7);
}

:deep(.van-image-preview) {
	.van-image-preview__index {
		color: #fff;
	}
}

.copyright {
	text-align: center;
	padding: 16px 0;

	span {
		font-size: 10.5px;
		color: #999;
	}
}
</style>
